import dayjs from 'dayjs';

export const INSUFFICIENT_CREDIT_TICKET_CATEGORIE = 'Demande ou réclamation diverse';
export const INSUFFICIENT_CREDIT_TICKET_NATURE = 'Demande ou réclamation diverse';

function formatStayDate(d) {
  if (d == null || d === '') return '';
  if (typeof d.format === 'function') return d.format('DD/MM/YYYY');
  const x = dayjs(d);
  return x.isValid() ? x.format('DD/MM/YYYY') : String(d);
}

function summarizeRooms(roomsConfig) {
  if (!Array.isArray(roomsConfig) || roomsConfig.length === 0) return '';
  return roomsConfig
    .map((r, i) => {
      const bits = [`${i + 1}`];
      if (r.room_type) bits.push(String(r.room_type));
      if (r.arrangement) bits.push(String(r.arrangement));
      bits.push(`${r.adults ?? 0} adulte(s)`);
      if (r.children) bits.push(`${r.children} enfant(s)`);
      return bits.join(' — ');
    })
    .join('\n');
}

/**
 * Full text for ticket.description + structured details for DB (JSON).
 */
export function buildMoteurInsufficientCreditTicketPayload({
  t,
  client,
  hotel,
  checkIn,
  checkOut,
  roomsConfig,
  economicModelLabel,
  billingLabel,
  totalAmountTnd,
  displayAmount,
  displayCurrency,
  balanceInfo,
}) {
  const objectLabel = t('moteurReservation.automaticPaymentMethods.ticket_prefill_object', {
    defaultValue: 'Solde insuffisant — réservation moteur',
  });

  const amtTnd = Number(totalAmountTnd) || 0;
  const disp = displayAmount != null ? Number(displayAmount(amtTnd)).toFixed(2) : amtTnd.toFixed(2);
  const cur = displayCurrency || 'TND';

  const plafond = balanceInfo?.plafond;
  const deposit = balanceInfo?.deposit;

  const roomsBlock = summarizeRooms(roomsConfig);

  const description = t('moteurReservation.automaticPaymentMethods.ticket_partner_notice_description', {
    defaultValue:
      "Votre réservation n'a pas pu être confirmée car votre solde disponible est insuffisant. Un ticket a été ouvert automatiquement auprès de notre équipe admin ; vous recevrez une réponse dès que possible. Détails: hôtel {{hotel}}, séjour du {{checkIn}} au {{checkOut}}, montant à couvrir {{disp}} {{cur}}.",
    hotel: hotel?.name || '—',
    checkIn: formatStayDate(checkIn) || '—',
    checkOut: formatStayDate(checkOut) || '—',
    disp,
    cur,
  });

  const details = {
    object_of_complaint: objectLabel,
    source: 'moteur_reservation_insufficient_credit',
    hotel_id: hotel?.id ?? null,
    hotel_name: hotel?.name ?? null,
    hotel_ville: hotel?.ville_name ?? null,
    hotel_pays: hotel?.pays_name ?? null,
    check_in: formatStayDate(checkIn) || null,
    check_out: formatStayDate(checkOut) || null,
    total_amount_tnd: amtTnd,
    amount_display: disp,
    display_currency: cur,
    client_id: client?.id ?? null,
    client_name: client?.name || client?.raison_sociale || null,
    economic_model: economicModelLabel || null,
    billing_label: billingLabel || null,
    rooms_summary: roomsBlock || null,
    balance_snapshot: balanceInfo
      ? {
          plafond_has: plafond?.hasPlafond ?? null,
          plafond_available_tnd: plafond?.hasPlafond ? Number(plafond?.availableAmount ?? 0) : null,
          deposit_has: deposit?.hasDeposit ?? null,
          deposit_available_tnd: deposit?.hasDeposit ? Number(deposit?.availableAmount ?? 0) : null,
        }
      : null,
  };

  return {
    categorie: INSUFFICIENT_CREDIT_TICKET_CATEGORIE,
    nature: INSUFFICIENT_CREDIT_TICKET_NATURE,
    sujet: objectLabel,
    description,
    details,
  };
}
